module.exports = __webpack_public_path__ + "img/car_icon.7e84b003.png";